module.exports = __webpack_public_path__ + "img/target.273d2bf7.png";